import { ReactElement } from 'react'

import FindByIdImpl from 'modules/lotes/domain/usecases/FindByIdImpl'
import VerificaCargaDisponivelImpl from 'modules/lotes/domain/usecases/VerificaCargaDisponivelImpl'
import DetalhesCargaScreen from 'modules/lotes/pages/DetalhesCarga'
import { ListFrotista } from 'modules/user/domain/usecases/ListFrotista'
import ValidateRequisitosViagemImpl from 'modules/user/domain/usecases/ValidateRequisitosViagemImpl'
import UserRepository from 'modules/user/infra/repositories/UserRepository'

import LoteRepository from '../../infra/repositories/LoteRepository'
import ValidateLoteQuarteirizadoImpl from 'modules/lotes/domain/usecases/ValidateLoteQuarteirizado'

export const DetalhesCargaFactory = (): ReactElement => {
  const loteRepository = new LoteRepository()
  const usuarioRepository = new UserRepository()
  const findBIdImpl = new FindByIdImpl(loteRepository)
  const verificaCargaDisponivelImpl = new VerificaCargaDisponivelImpl(
    loteRepository,
  )
  const validateRequisitosViagemImpl = new ValidateRequisitosViagemImpl(
    usuarioRepository,
  )
  const listFrotistas = new ListFrotista(usuarioRepository)
  const validateLoteQuarteirizado = new ValidateLoteQuarteirizadoImpl(
    loteRepository,
  )
  return (
    <DetalhesCargaScreen
      findById={findBIdImpl}
      verificaCargaDisponivel={verificaCargaDisponivelImpl}
      validateRequisitosViagem={validateRequisitosViagemImpl}
      listFrotistas={listFrotistas}
      validateLoteQuarteirizado={validateLoteQuarteirizado}
    />
  )
}
